<template>
  <ul class="achievement-list" :class="{ 'interact': interact }">
    <li v-for="(achievement, index) in achievements" :key="achievement.id" class="achievement-list-item">
      <button
        v-if="interact"
        type="button"
        @click="handleAchievementClick(achievement)"
        :aria-label="`Select ${achievement.name}`"
      >
        <achievement-item
          :achievement="achievement"
          :editable="editable"
          :achievement-type="achievementType"
          @remove-achievement="$emit('remove-achievement', index)"
          @threshold-score="$emit('threshold-score', {index, threshold: $event})"
        ></achievement-item>
      </button>
      <div v-else>
        <achievement-item
          :achievement="achievement"
          :editable="editable"
          :achievement-type="achievementType"
          @remove-achievement="$emit('remove-achievement', index)"
          @threshold-score="$emit('threshold-score', {index, threshold: $event})"
        ></achievement-item>
      </div>
    </li>
  </ul>
</template>

<style scoped>
.achievement-list {
  list-style: none;
  padding: 0;
  margin-bottom: 1em;
}

.achievement-list > li {
  display: flex;
  padding: 0;
  border-bottom: 2px solid var(--kate-primary-dark);
}

.achievement-list > li > button,
.achievement-list > li > div {
  display: flex;
  width: 100%;
  padding: 1em;
  border: none;
  background: transparent;
  text-align: left;
  font-family: inherit;
}

.achievement-list.interact > li > button {
  cursor: pointer;
}

.achievement-list.interact > li > button:hover {
  background-color: var(--kate-button-primary-hover);
}

.achievement-list.interact > li > button:focus-visible {
  outline: 2px solid var(--kate-neon-primary-text);
  outline-offset: -2px;
}
</style>

<script>
import AchievementItem from './achievement-item.vue';

export default {
  components: {
    AchievementItem,
  },

  props: {
    interact: {
      type: Boolean,
      default: false,
    },
    achievements: {
      type: Array,
    },
    achievementType: {
      type: String,
      default: 'achievement',
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleAchievementClick(achievement) {
      if (this.interact) {
        this.$emit('achievement-click', achievement);
      }
    },
  },
};
</script>
